import { render, staticRenderFns } from "./Xxn.vue?vue&type=template&id=13df2c32&scoped=true&"
import script from "./Xxn.vue?vue&type=script&lang=js&"
export * from "./Xxn.vue?vue&type=script&lang=js&"
import style0 from "./Xxn.vue?vue&type=style&index=0&id=13df2c32&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13df2c32",
  null
  
)

export default component.exports